import { Navigation } from 'components'
import Text from 'components/priority/Text/Text'

export const Assets = () => {
  return (
    <>
      <Navigation type="admin" />
      <Text margin="32px 0 0 0">Assets</Text>
    </>
  )
}

export default Assets
